import { toClassName } from '../components/shared_functions'

export const PALETTE = [
  '#E9EBEE',
  '#F1D2D2',
  '#F1E0D2',
  '#F1EED3',
  '#E1F1D3',
  '#D2F0E4',
  '#D2E7F0',
  '#D1D5F0',
  '#E7D2F0'
]

export const WBS_COLORS = [
  'eff1f4', 
  '#cbecdd', 
  '#c5d3f2', 
  '#fac7d2', 
  '#fffea8'
]

export const PROGRESS_PALETTE = [
  '#F4F269',
  '#E5EC6A',
  '#D6E56A',
  '#C6DF6B',
  '#B7D86C',
  '#A8D26D',
  '#99CC6D',
  '#8AC56E',
  '#7ABF6F',
  '#6BB86F',
  '#5CB270'
]

function idToColor(id) {
  // const colorIndex = hashStringToInt(String(id), PALETTE.length)
  const colorIndex = Number(id) % PALETTE.length
  return PALETTE[colorIndex]
}

export const objectStyleByLegend = (object, legend) => {
  if (object[legend] === null) {
    return {}
  }
  const id = parseInt(object[legend])

  const ret = {
    backgroundColor: undefined,
    color: undefined
  }

  if (legend == 'priority') {
    if (object.priority && window.appData.priority_colors[object.priority]) {
      ret.backgroundColor = window.appData.priority_colors[object.priority]
    }
    if (object.priority == 'critical') {
      ret.color = '#fff'
    }
  } else if (Object.keys(window.appData.elements_colors).includes(legend)) {
    if (window.appData.elements_colors[legend][id]) {
      ret.backgroundColor = window.appData.elements_colors[legend][id]
    } else {
      ret.backgroundColor = '#fff'
    }
    if (ret.backgroundColor == '#000') {
      ret.color = '#fff'
    }    
  } else if (legend == 'progress') {
    const index = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].indexOf(Math.round(object.progress / 10))
    if (object.progress <= 50) {
      ret.color = '#000'
      ret.textShadow = '0px 0px 3px #FFF'
    } else {
      ret.color = '#FFF'
      ret.textShadow = '0px 0px 3px #000'
    }
    ret.backgroundColor = PROGRESS_PALETTE[index]
  } else if (legend == 'wbs_color') {
    ret.backgroundColor = object.wbs_color
  } else if (legend == 'user_color') {
    if (object.type == 'task' || object.type == 'company') {
      if (object.target_user_id) {
        ret.backgroundColor = idToColor(object.target_user_id)
      }
    } else if (object.user_id) {
      ret.backgroundColor = idToColor(object.user_id)
    }
  } else if (legend == 'project_color') {
    ret.backgroundColor = idToColor(object.project_color.id)
  } else if (legend == 'company_color') {
    ret.backgroundColor = idToColor(object.company_color.id)
  } else {
    ret.backgroundColor = window.appData.elements[toClassName(legend)].find((e) => e.id === id)?.color
    if (ret.backgroundColor == '#000') ret.color = '#fff'
  }
  if (ret.backgroundColor) {
    ret.border = `1px solid ${ret.backgroundColor}`
  }
  return ret
}


export const objectColorByLegend = (object, legend) => {
  if (!legend) return null

  if (object[legend] === null) {
    return '#fff'
  }
  const id = parseInt(object[legend])

  let color = '#fff'

  if (legend == 'priority') {
    if (object.priority && window.appData.priority_colors[object.priority]) {
      color = window.appData.priority_colors[object.priority]
    }
  } else if (Object.keys(window.appData.elements_colors).includes(legend)) {
    if (window.appData.elements_colors[legend][id]) {
      color = window.appData.elements_colors[legend][id]
    } else {
      color = '#fff'
    }
  } else if (legend == 'progress') {
    const index = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].indexOf(Math.round(object.progress / 10))
    color = PROGRESS_PALETTE[index]
  } else if (legend == 'wbs_color') {
    color = object.wbs_color
  } else if (legend == 'user_color') {
    if (object.type == 'task' || object.type == 'company') {
      if (object.target_user_id) {
        color = idToColor(object.target_user_id)
      }
    } else if (object.user_id) {
      color = idToColor(object.user_id)
    }
  } else if (legend == 'project_color') {
    color = idToColor(object.project_color.id)
  } else if (legend == 'company_color') {
    color = idToColor(object.company_color.id)
  } else if (legend) {
    color = window.appData.elements[toClassName(legend)].find((e) => e.id === id)?.color
    if (color == '#000') color = '#fff'
  }

  return color
}
